import React from 'react';
import ComponentImage from '../../components/Image/Image';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import Routes from '../Router/Routes'
import { useNavigate } from 'react-router';

const ImageBanner = (props) => {
    const navigate = useNavigate();
    return (
        <div className={`${props.className}`} >
            <ComponentImage imageSrc={props.imageSrc} height='75vh' />
            {/* <h1>{Translate({id:"homePage.SeeAllClasses"})}</h1> */}
            <div className={props.isOverlay ? "overlay" : "home-content"}>
                <div className={props.isOverlay ? "centeredText marketing-banner" : ""}>
                    <Typography className="App-intro-wexer m-t-xs-20 market-tag-h1"
                        // style={FontStyle.SFProDisplayBig}
                        variant="h1"
                    >{props.marketingTagLine}
                    </Typography>
                    <Typography className="centeredTextDescription"
                    variant="subtitle1"
                    >{props.marketingDescription}</Typography>
                    <Button variant="contained" color="secondary" className="button btn-default hero-button"
                        
                        onClick={() => { navigate(Routes.homePage); }} >
                        <Typography variant="button">{props.buttonText ? props.buttonText : "Browse"}</Typography>
                    </Button>
                </div>
            </div>
        </div>
)
};

export default ImageBanner;